import React, {useEffect} from 'react';
import { Helmet } from "react-helmet";
import config from '../../config/config';

export default function Calqulator() {

    // dynamicaly adding script and link tag because of reloading issue
    useEffect(() => {
        const delayExecution = setTimeout(() => {
          const script = document.createElement('script');
          script.src = `${config.calculatorJsUrl}`;  
          const link = document.createElement('link');
          link.href = `${config.calculatorCssUrl}`;
          link.rel = 'stylesheet';
    
          document.head.appendChild(script);
          document.head.appendChild(link);
        }, 1000);
    
        return () => clearTimeout(delayExecution);
      }, []);

    return (
        <div>
            <div className="calculator-widget">
            </div>
        </div>
    )
}
